/* @ngInject */
export default function $sceConfig($sceDelegateProvider, appConfig) {
  let whiteList = [
    // Allow same origin resource loads.
    'self',
    // Allow loading from our assets' domain.  Notice the difference between * and **.,
    'https://pc3-media.s3.amazonaws.com/**',
    'https://pc-prod.s3.amazonaws.com/**',
    'https://s3.amazonaws.com/**',
    // Allow portal panels to fetch resources from our proxy endpoint
    'https://*iframe.twenty20solutions.com/**',
    'https://*iframe-stg.twenty20solutions.com/**',
    'https://*iframe-dev.twenty20solutions.com/**',
    // charts.mongodb.com intentionally omitted — MongoDB Charts is no longer
    // used; no instances remain. Do not re-add without confirming active use.
    // Add Acoem Cadence
    'https://cadence.acoem.com/**',
    // Add epic io sites
    'https://*.epicio.com/**',
    'https://*.iframe.epicio.com/**',
    'https://*.epicio-zt.com/**',
    'https://*.epicio.net/**',
  ];
  if (appConfig.pc3Env === 'development') {
    whiteList = ['**'];
  }
  $sceDelegateProvider.resourceUrlWhitelist(whiteList);
}
